import dayjs from "dayjs";

const month = 30 * 24 * 60 * 60 * 1000 * 10;
const day = 1000 * 60 * 60 * 24;
const hour = 1000 * 60 * 60;
const minute = 1000 * 60;

const hadleDiff = (createdAt: any) => new Date() - Date.parse(createdAt);

const formatArticles = (initData: any) =>
  initData.map((item: any) => ({
    ...item,
    // 1.N 分钟前
    // 2.大于60分钟：N 小时前
    // 3.大于24小时：N 天前
    // 4.大于30天：YYYY-MM-DD
    updatedTime: item.createdAt
      ? hadleDiff(item.createdAt) >= month
        ? dayjs(item.createdAt).format("YYYY-MM-DD")
        : hadleDiff(item.createdAt) >= day
          ? Math.ceil(hadleDiff(item.createdAt) / day) + " 天前"
          : hadleDiff(item.createdAt) >= hour
            ? Math.ceil(hadleDiff(item.createdAt) / hour) + " 小时前"
            : Math.ceil(hadleDiff(item.createdAt) / minute) + " 分钟前"
      : "",
  }));

export { formatArticles };
